import { Expose } from 'class-transformer';
import { Model } from './model';

export class DashboardBalanceReport extends Model {
  @Expose() balanceMinutes: number[];
  @Expose() consumedMinutes: number[];
  @Expose() remainMinutes: number[];
}
